export default __webpack_public_path__ + "688008097bc0cd6387457443f954618e.woff2";